import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private _storage: Storage | null = null;

  static Keys: any = {
    menuIsCollapsed: 'sidebar.menuIsCollapsed',
    themeMode: 'header.theme-mode'
  }

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    this._storage = await this.storage.create();
  }

  public async set(key: string, value: any): Promise<any> {
    try {
      const storedValue = await this._storage?.set(key, value);
      return storedValue;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public async get(key: string): Promise<any> {
    try {
      if (!this._storage) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            this.get(key).then(resolve).then(reject);
          }, 200);
        })
      }
      const storedValue = await this._storage?.get(key);
      return storedValue;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public async remove(key: string) {
    try {
      await this._storage?.remove(key);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  public async clear() {
    try {
      await this._storage?.clear();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}
